import React from "react";
import "./Skill.scss";

function Skill() {
  return <div>Skill</div>;
}

export default Skill;
